import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectPassengerInfo: {},
  isLoading: false,
  hasData: false,
  error: "",
  selectPassengerStatus: {
    status: false,
    message: ""
  },
  selectedPassengerData: {},
  editMode: false,
  passengerData: {},
  passengerDataStatus: {
    status: false,
    message: ""
  }
};
const selectPassengerSlice = createSlice({
  name: "selectPassenger",
  initialState,
  reducers: {
    passengerDataRequest: (state, action) => {
      state.isLoading = true;
    },
    passengerDataSuccess: (state, action) => {
      state.isLoading = false;
      state.passengerData = action.payload;
      state.passengerDataStatus.status = true;
      state.passengerDataStatus.message = action?.payload?.message || "";
    },
    passengerDataFailure: (state, action) => {
      state.isLoading = false;
      state.passengerData = {};
      state.passengerDataStatus.status = false;
      state.passengerDataStatus.message = "";
      state.error = action?.payload?.response?.data;
    },
    selectPassengerRequest: (state, action) => {
      state.isLoading = true;
    },
    selectPassengerSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.selectPassengerInfo = action.payload;
      state.selectPassengerStatus.status = true;
      state.selectPassengerStatus.message = action?.payload?.message;
    },
    selectPassengerFailure: (state, action) => {
      state.isLoading = false;
      state.error = action?.payload?.response?.data;
      state.selectPassengerInfo = {};
      state.selectPassengerStatus.status = false;
      state.selectPassengerStatus.message = "";
    },
    resetRemovePassengers: state => {
      state.selectPassengerInfo = {};
      state.selectedPassengerData = {};
      state.isLoading = false;
      state.hasData = false;
      state.error = "";
      state.selectPassengerStatus.status = false;
      state.selectPassengerStatus.message = "";
    },
    setSelectPassengerData: (state, action) => {
      state.selectedPassengerData = action.payload;
    },
    enableEditMode: state => {
      state.editMode = true;
    },
    disableEditMode: state => {
      state.editMode = false;
    },
    resetPaxDetails: state => {
      state.selectPassengerInfo = {};
    },
    resetPassengerDataStatus: state => {
      state.passengerData = {};
      if (!state.passengerDataStatus) {
        state.passengerDataStatus = {
          status: false,
          message: ""
        };
      }
      state.passengerDataStatus.status = false;
      state.passengerDataStatus.message = "";
    }
  }
});
export const {
  selectPassengerRequest,
  selectPassengerSuccess,
  selectPassengerFailure,
  resetRemovePassengers,
  setSelectPassengerData,
  enableEditMode,
  disableEditMode,
  passengerDataRequest,
  passengerDataSuccess,
  passengerDataFailure,
  resetPaxDetails,
  resetPassengerDataStatus
} = selectPassengerSlice.actions;
export default selectPassengerSlice.reducer;